// FILE: /src/Components/Apps/AppCreditBadge.js

import React from "react";
import { Tooltip } from "antd";

const AppCreditBadge = ({
  cost,
  credits,
  showRemaining = false,
  size = "default",
}) => {
  const costCredits = Number(cost?.credits || cost || 0);
  const remainingCredits = Number(credits?.remainingCredits || 0);
  const hasEnoughCredits = remainingCredits >= costCredits;

  const sizeClasses =
    size === "small"
      ? "text-xs px-2 py-1"
      : "text-sm px-3 py-1.5";

  if (!showRemaining) {
    return (
      <span
        className={`inline-flex items-center gap-1 rounded-full bg-purple-50 text-purple-700 font-semibold border border-purple-100 ${sizeClasses}`}
      >
        <i className="fa-solid fa-bolt text-yellow-500"></i>
        {costCredits} credit{costCredits === 1 ? "" : "s"}
      </span>
    );
  }

  return (
    <Tooltip
      title={
        hasEnoughCredits
          ? `${remainingCredits} credits remaining`
          : `Not enough credits. You need ${costCredits}, but have ${remainingCredits}.`
      }
    >
      <span
        className={`inline-flex items-center gap-1 rounded-full font-semibold border ${sizeClasses} ${
          hasEnoughCredits
            ? "bg-green-50 text-green-700 border-green-100"
            : "bg-red-50 text-red-700 border-red-100"
        }`}
      >
        <i className="fa-solid fa-bolt text-yellow-500"></i>
        {costCredits} credit{costCredits === 1 ? "" : "s"}
        <span className="text-gray-400 mx-1">•</span>
        {remainingCredits} left
      </span>
    </Tooltip>
  );
};

export default AppCreditBadge;